export function searchSelector(state = {}) {
  return state.searchV9 || {};
}

export function getProviderIds(state = {}) {
  return searchSelector(state).providerIds || [];
}

export function querySelector(state = {}) {
  return searchSelector(state).query;
}

export function searchSummarySelector(state = {}) {
  return searchSelector(state).searchSummary;
}
